<template>
  <div>
    <el-dialog width="500px" :visible.sync="dialogVisible" :show-close="false">
      <template slot="title">
        <div class="title" v-show="stepIndex === 0">{{ $t("oops.title") }}</div>
        <div class="title" v-show="stepIndex === 1">
          {{ $t("oops.enter") }}
        </div>
        <div class="title" v-show="stepIndex === 2">{{ $t("oops.tips1") }}</div>
        <div class="title" v-show="stepIndex === 4">{{ $t("Select the Device") }}</div>
      </template>
      <div class="body" v-show="stepIndex === 0">
        <div class="text">
          {{ $t("oops.tips2") }}
        </div>
        <div class="text">
          {{ $t("oops.tip3") }}
        </div>
        <div class="btns">
          <div class="btn" @click="dialogVisible = false">
            {{ $t("oops.notNow") }}
          </div>
          <div class="btn y" @click="goStep(1)">{{ $t("oops.continue") }}</div>
        </div>
      </div>
      <div class="body" v-show="stepIndex === 1">
        <div class="Enter">
          <div>{{ $t("oops.id") }}</div>
          <input v-model="apple.apple_id" :placeholder="$t('enter.placeholder')" />
        </div>
        <div class="Enter">
          <div>{{ $t("oops.password") }}</div>
          <input v-model="apple.apple_pwd" :type="isshow ? 'password' : ''" :placeholder="$t('Enter your password')" />
          <img v-if="!isshow" @click="isshow = !isshow" src="@/assets/img/ege.png" alt="" />
          <img v-if="isshow" @click="isshow = !isshow" src="@/assets/img/ege1.png" alt="" />
        </div>
        <div class="btns">
          <div class="btn" @click="goStep(0)">{{ $t("oops.back") }}</div>
          <div class="btn y" @click="getVerCode(0)">
            {{ $t("oops.continue") }}
          </div>
        </div>
      </div>
      <div class="body" v-show="stepIndex === 2">
        <div class="Take">{{ $t("oops.tips4") }}</div>
        <div id="Verification">
          <input @click="input0 = ''" v-model="input0" v-on:input="tab(1)" data-index="1" ref="input0" maxlength="1" />
          <input @click="input1 = ''" v-model="input1" v-on:input="tab(2)" ref="input1" maxlength="1" />
          <input @click="input2 = ''" v-model="input2" v-on:input="tab(3)" ref="input2" maxlength="1" />
          <input @click="input3 = ''" v-model="input3" v-on:input="tab(4)" ref="input3" maxlength="1" />
          <input @click="input4 = ''" v-model="input4" v-on:input="tab(5)" ref="input4" maxlength="1" />
          <input @click="input5 = ''" v-model="input5" ref="input5" maxlength="1" />
        </div>
        <div class="Take">
          {{ $t("oops.tips5") }}
          <span @click="getVerCode(1)" v-if="countDown === 60">{{
            $t("oops.tips6")
            }}</span>
          <span v-else>{{ countDown }}s</span>
        </div>
        <div class="Take code" v-show="isshow1">
          {{ $t("oops.tip7") }}
        </div>
        <div class="btns">
          <div class="btn" @click="goStep(1)">{{ $t("oops.back") }}</div>
          <div class="btn y" @click="oks">{{ $t("oops.continue") }}</div>
        </div>
      </div>
      <div class="body" style="text-align: center" v-if="stepIndex === 3">
        <img style="width: 64px; height: 64px" src="@/assets/img/oks.png" alt="" />
        <div id="ok" style="
          font-size: 16px;
          color: #000927;
          font-weight: 700;
          width: 300px;
          text-align: center;
          margin: 20px auto 0;
          font-family: Noto Sans;
        ">
          {{ $t("oops.tip8") }}
        </div>
        <div class="btns">
          <div class="btn y" style="margin: 0 auto; flex: 0 280px" @click="dialogVisible = false">
            {{ $t("oops.tip9") }}
          </div>
        </div>
      </div>
      <!-- 步骤4：选择设备 -->
      <div class="body" v-show="stepIndex === 4">
        <div class="equipment-box">
          <div
            class="equipment-item"
            v-for="(item, index) in equipmentList"
            :key="index"
            @click="onSelectequipment(item, index)"
          >
            <img
              :src="
                equipmentIndex === index
                  ? require('@/assets/img/qdui.png')
                  : require('@/assets/img/qnodui.png')
              "
              alt=""
              class="equipment-icon"
            />
            <span class="equipment-name">{{ item }}</span>
          </div>
        </div>
        <div class="btns">
          <div class="btn" @click="goStep(1)">{{ $t("selectTheDevice.back") }}</div>
          <div class="btn y" @click="onSelectDevice">{{ $t("selectTheDevice.continue") }}</div>
        </div>
      </div>
    </el-dialog>
    <sign-in-retry-dialog v-model="retryDialogVisible" :status="retryDialogStatus" @edit="onEditCredential"
      @retry="onRetrySignIn" />
    <SignInToICloudDialog v-model="icloudDialogVisible" />
  </div>
</template>

<script>
import {
  BinddeviceBindApple,
  appleVerficationCodeNew,
  updateIosDeviceName,
} from "@/api/user";
import SignInRetryDialog from "@/components/SignInRetryDialog.vue";
import SignInToICloudDialog from "@/components/SignInToICloudDialog.vue";
const throttle = (fn, interval = 0, resetInterval = false) => {
  let [_self, timer, isFirst] = [fn, undefined, true];
  return function () {
    if (isFirst && !resetInterval) {
      _self.apply(this, arguments);
      // eslint-disable-next-line no-return-assign
      return (isFirst = false);
    }
    if (timer) {
      if (resetInterval) {
        clearTimeout(timer);
        timer = undefined;
      } else {
        return false;
      }
    }
    timer = setTimeout(() => {
      clearTimeout(timer);
      timer = undefined;
      _self.apply(this, arguments);
    }, interval);
  };
};
export default {
  components: { SignInRetryDialog, SignInToICloudDialog },
  data() {
    return {
      dialogVisible: false,
      stepIndex: 2,
      apple: {
        apple_id: "",
        apple_pwd: "",
      },
      isshow: false,
      isshow1: false,
      input0: "",
      input1: "",
      input2: "",
      input3: "",
      input4: "",
      input5: "",
      isResend: false,
      countDown: 60,
      timer: null,
      isDisabled: false,
      retryDialogVisible: false,
      retryDialogStatus: "failed",
      icloudDialogVisible: false,
      // 选择设备
      equipmentList: [],
      equipmentIndex: -1,
      equipmentName: "",
    };
  },
  mounted() {
    //   增加节流
    this.tab = throttle(this.tab, 100, true);
    let _this = this;
    window.addEventListener("paste", function (e) {
      const clipdata = e.clipboardData || window.clipboardData;
      let code = clipdata.getData("text/plain");
      if (_this.stepIndex === 2) {
        setTimeout(() => {
          _this.input0 = code[0];
          _this.input1 = code[1];
          _this.input2 = code[2];
          _this.input3 = code[3];
          _this.input4 = code[4];
          _this.input5 = code[5];
          _this.$refs.input5.focus();
        }, 500);
      }
    });
  },
  watch: {
    countDown(value) {
      if (value <= 0) {
        clearInterval(this.timer);
        this.timer = null;
        this.countDown = 60;
      }
    },
  },
  methods: {
    open() {
      this.goStep(0);
      this.dialogVisible = true;
    },
    goStep(e) {
      this.stepIndex = e;
      if (e === 2) {
        this.input0 = "";
        this.input1 = "";
        this.input2 = "";
        this.input3 = "";
        this.input4 = "";
        this.input5 = "";
        this.$nextTick(() => {
          setTimeout(() => {
            this.$refs.input0.focus();
          });
        });
      } else if (e === 1) {
        this.apple = {
          apple_id: "",
          apple_pwd: "",
        };
      }
    },
    setValue(e, a) {
      console.log(e, a);
    },
    //  切换输入框
    tab(a) {
      if (a === 1) {
        this.$refs.input1.focus();
        this.input1 = "";
      }
      if (a === 2) {
        this.$refs.input2.focus();
        this.input2 = "";
      }
      if (a === 3) {
        this.$refs.input3.focus();
        this.input3 = "";
      }
      if (a === 4) {
        this.$refs.input4.focus();
        this.input4 = "";
      }
      if (a === 5) {
        this.$refs.input5.focus();
        this.input5 = "";
      }
    },
    // 绑定设备
    oks() {
      if (this.isDisabled) {
        return;
      }
      let key = {
        equipment_id: localStorage.getItem("systemId"),
        code:
          this.input0 +
          this.input1 +
          this.input2 +
          this.input3 +
          this.input4 +
          this.input5,
      };
      if (this.isResend) {
        key.is_resend = 1;
      }
      this.isDisabled = true;
      appleVerficationCodeNew(key)
        .then((adj) => {
          this.isDisabled = false;
          if (adj.code === -1) {
            this.$message.error(this.$t("oops.message"));
            this.goStep(1);
          } else if (adj.code === 11 || adj.code === 10) {
            // 设备列表已返回 → 进入选择设备步骤
            this.equipmentList = adj.data || [];
            this.equipmentIndex = -1;
            this.equipmentName = "";
            this.goStep(4);
          } else {
            this.isshow1 = true;
            this.input0 = null;
            this.input1 = null;
            this.input2 = null;
            this.input3 = null;
            this.input4 = null;
            this.input5 = null;
            this.$refs.input0.focus();
            this.$message.error(adj.msg);
          }
        })
        .catch(() => {
          this.isDisabled = false;
        });
    },
    // 获取验证码
    getVerCode(type) {
      if (type === 1 && (!this.isDisabled && this.countDown === 60)) {
        this.isDisabled = true;
        this.countDown -= 1;
        this.timer = setInterval(() => {
          this.countDown -= 1;
        }, 1000);
      }
      const params = {
        ...this.apple,
        equipment_id: localStorage.getItem("systemId"),
      };
      if (type === 1) {
        params.is_resend = 1;
      }
      BinddeviceBindApple(params)
        .then((adj) => {
          this.isDisabled = false;
          if (adj.code === 0) {
            this.$message.error(adj.msg);
            return false;
          }
          if (adj.code === 1001) {
            // 账号密码验证失败 → 弹出冷却重试弹窗
            this.retryDialogStatus = "failed";
            this.retryDialogVisible = true;
            return false;
          }
          if (adj.code === 1003) {
            // 需先去 iCloud.com 登录 → 弹出引导弹窗
            this.icloudDialogVisible = true;
            return false;
          }
          // 重发成功后才标记 isResend，失败则不影响后续提交
          if (type === 1) {
            this.isResend = true;
          }
          if (adj.code === 2) {
            if (type === 0) {
              this.goStep(2);
            } else if (type === 1) {
              this.$nextTick(() => {
                setTimeout(() => {
                  this.$refs.input0.focus();
                });
              });
            }
          } else if (adj.code === 10 || adj.code === 11) {
            // 设备列表已返回 → 进入选择设备步骤
            this.equipmentList = adj.data || [];
            this.equipmentIndex = -1;
            this.equipmentName = "";
            this.goStep(4);
          }
        })
        .catch(() => {
          this.isDisabled = false;
        });
    },
    // 点击"编辑账号密码"→ 关闭弹窗，回到账号密码输入步骤
    onEditCredential() {
      this.retryDialogVisible = false;
      this.goStep(1);
    },
    // 选择设备
    onSelectequipment(item, index) {
      this.equipmentIndex = index;
      this.equipmentName = item;
    },
    // 确认选择设备，调用更新接口
    onSelectDevice() {
      if (!this.equipmentName) {
        this.$message.error(this.$t("selectTheDevice.msg"));
        return;
      }
      if (this.isDisabled) return;
      this.isDisabled = true;
      const key = {
        equipment_id: localStorage.getItem("systemId"),
        name: this.equipmentName,
      };
      updateIosDeviceName(key)
        .then((adj) => {
          this.isDisabled = false;
          if (adj.code === 1) {
            // 绑定成功
            this.$emit("init");
            this.goStep(3);
          } else {
            this.$message.error(adj.msg);
          }
        })
        .catch(() => {
          this.isDisabled = false;
        });
    },
    // 冷却结束后点击"Try again"→ 切换重试中状态，重新调用绑定接口
    onRetrySignIn() {
      this.retryDialogStatus = "retrying";
      const params = {
        ...this.apple,
        equipment_id: localStorage.getItem("systemId"),
        is_retry: 1,
        is_resend: 1,
      };
      BinddeviceBindApple(params)
        .then((adj) => {
          this.retryDialogVisible = false;
          if (adj.code === 0) {
            this.$message.error(adj.msg);
          } else if (adj.code === 1001) {
            // 再次失败 → 重新弹出冷却弹窗
            this.retryDialogStatus = "failed";
            this.retryDialogVisible = true;
          } else if (adj.code === 1003) {
            // 需先去 iCloud.com 登录 → 弹出引导弹窗
            this.icloudDialogVisible = true;
          } else if (adj.code === 2) {
            this.goStep(2);
          } else if (adj.code === 10 || adj.code === 11) {
            // 设备列表已返回 → 进入选择设备步骤
            this.equipmentList = adj.data || [];
            this.equipmentIndex = -1;
            this.equipmentName = "";
            this.goStep(4);
          }
        })
        .catch(() => {
          this.retryDialogVisible = false;
          this.$message.error(this.$t("signInRetry.failedTitle"));
        });
    },
  },
};
</script>

<style>
.el-dialog {
  border-radius: 12px !important;
}

.el-dialog__header {
  /* padding: 0 20px; */
  padding: 30px 48px 35px !important;
}

.el-dialog__body {
  padding: 0 48px 20px !important;
  word-break: break-word !important;
}

.title {
  font-size: 20px;
}

.body {
  font-size: 14px;
  color: grey;
  font-family: Noto Sans;
}

.body .text {
  margin-bottom: 20px;
}

.body .btns {
  display: flex;
  align-items: center;
  justify-content: center;
  /* margin: 0 10%; */
  margin-top: 40px;
  margin-bottom: 50px;
}

.body .btns .btn {
  cursor: pointer;
  flex: 0 0 150px;
  height: 36px;
  line-height: 36px;
  text-align: center;
  font-size: 15px;
  color: #000927;
  border: 2px solid #00eec3;
  border-radius: 22px;
  font-family: Noto Sans;
  margin: 0 30px;
}

.body .btns .btn.y {
  text-align: center;
  border-radius: 25px;
  background: #00eec3;
  font-weight: 700;
  color: #000927;
  box-shadow: 0 2px 6px rgb(8 145 120 / 50%);
  cursor: pointer;
  font-family: Noto Sans !important;
  user-select: none;
  flex: 0 0 150px;
  height: 40px;
  line-height: 40px;
  font-size: 15px;
}

.Enter {
  font-size: 14px;
  color: #000927;
  line-height: 20px;
  margin-bottom: 30px;
  position: relative;
}

.Enter div {
  margin-bottom: 8px;
  height: 20px;
}

.Enter input {
  width: 100%;
  height: 50px;
  line-height: 50px;
  font-size: 14px;
  border: 1px solid #d5d7db;
  border-radius: 8px;
  text-indent: 10px;
}

.Enter img {
  position: absolute;
  right: 20px;
  width: 16px;
  height: 16px;
  top: 45px;
  cursor: pointer;
}

.Take {
  font-size: 14px;
  color: grey;
  line-height: 20px;
}

.Take span {
  /*color: #0080ff;*/
  color: #808080;
  cursor: pointer;
}

.Take.code {
  color: #ff0000;
  margin-top: 30px;
}

#Verification {
  margin: 40px 0 40px;
  overflow: hidden;
}

#Verification input {
  float: left;
  background: #f6f8fa;
  border: 2px solid #d5d7db;
  width: 38px;
  height: 58px;
  border-radius: 10.67px;
  font-size: 32px !important;
  color: #000927;
  text-align: center !important;
  font-weight: 700 !important;
  font-family: Noto Sans !important;
  margin-right: 20px;
}

#Verification input:focus {
  border: 2px solid #00eec3;
}

/* 选择设备 */
.equipment-box {
  width: 100%;
  max-height: 320px;
  overflow-y: auto;
  border: 1px solid #d5d7db;
  border-radius: 8px;
  box-sizing: border-box;
  padding: 0 12px;
}

.equipment-item {
  display: flex;
  align-items: center;
  padding: 22px 0;
  cursor: pointer;
  border-bottom: 1px solid #f0f0f0;
}

.equipment-item:last-child {
  border-bottom: none;
}

.equipment-icon {
  width: 20px;
  height: 20px;
  margin-right: 12px;
  flex-shrink: 0;
}

.equipment-name {
  font-size: 16px;
  font-weight: 700;
  color: #000927;
  font-family: Noto Sans;
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/Oops.vue